<template>
  <BaseLocaleLink
    v-slot="{ isActive, isExactActive }"
    :to="item.route"
    class="focus-visible:outline-none focus:ring rounded-xl"
    :data-test="item.id"
  >
    <div
      class="text-gray transition duration-150 ease-in-out flex items-center gap-2 rounded-xl"
      :class="[
        proxySize,
        (isActive && item.isCategory) || isExactActive || item.isActive
          ? proxyTheme.active
          : proxyTheme.bg,
      ]"
    >
      <BaseIcon
        v-if="item.icon"
        :name="item.icon"
        size="sm"
        :class="item.iconClass || undefined"
      />
      <div class="truncate">{{ item.local }}</div>
      <BaseIcon
        v-if="item.rightIcon"
        v-show="item.rightIcon?.isShow"
        :name="item.rightIcon.name"
        :class="item.rightIcon.class"
        class="ml-auto"
        size="sm"
      />
    </div>
  </BaseLocaleLink>
</template>

<script setup lang="ts">
import type { MenuItem } from '~/models/menu'

const sizes = {
  xs: 'py-1 px-2 text-xs',
  sm: 'py-2 px-4',
}

const themes = {
  primary: {
    bg: 'bg-primary-100 hover:bg-primary-400',
    active: 'bg-primary-400',
  },
  dark: {
    bg: 'hover:bg-ocean',
    active: 'bg-ocean',
  },
  light: {
    bg: 'hover:bg-primary-100',
    active: 'bg-primary-100',
  },
  white: {
    bg: 'bg-white hover:bg-ocean',
    active: 'bg-ocean',
  },
}

interface PropsInterface {
  item: MenuItem
  size?: keyof typeof sizes
  theme?: keyof typeof themes
}

const props = withDefaults(defineProps<PropsInterface>(), {
  size: 'sm',
  theme: 'dark',
})

const proxyTheme = computed(() => props.theme && themes[props.theme])
const proxySize = computed(() => props.size && sizes[props.size])
</script>
